var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonConforme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z",
    fill: "#E02819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83832 8.02419L5.67287 2.36328H7.29196L7.11469 8.02419H5.83832ZM6.51196 10.7187C6.22832 10.7187 5.9959 10.6321 5.81469 10.4587C5.64135 10.2854 5.55469 10.0766 5.55469 9.83237C5.55469 9.58025 5.64135 9.36752 5.81469 9.19419C5.9959 9.02086 6.22832 8.93419 6.51196 8.93419C6.77984 8.93419 7.00045 9.02086 7.17378 9.19419C7.35499 9.36752 7.4456 9.58025 7.4456 9.83237C7.4456 10.0766 7.35499 10.2854 7.17378 10.4587C7.00045 10.6321 6.77984 10.7187 6.51196 10.7187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonConforme);
export default __webpack_public_path__ + "static/media/non-conforme.171e70b256f6d1fa08bac11da466cf6d.svg";
export { ForwardRef as ReactComponent };